import { createComponentStore } from '../../utils/createComponentStore';

const initData = () => ({
  targetDatabaseId: null,
  availableColumns: [],
  queries: [],
});

const onLoadData = (rawData) => {
  const data = { ...initData(), ...rawData };
  // v1 compat: availableCols → availableColumns
  if (rawData.availableCols && !rawData.availableColumns) {
    data.availableColumns = rawData.availableCols;
    delete data.availableCols;
  }
  // v1 compat: queryData → queries
  if (rawData.queryData && !rawData.queries) {
    data.queries = rawData.queryData;
    delete data.queryData;
  }
  return data;
};

const { getStore: getQueryDatabaseStore, defaultStore } = createComponentStore({
  type: 'query_database',
  endpoint: 'query_database_record',
  registryKey: 'query_database_record',
  initData,
  onLoadData,

  extraState: (set, get) => ({
    placeholders: [],
    position: null,
    focus: null,
  }),

  extraActions: (set, get) => ({
    // Backward-compat alias — delegates to the factory-provided setComponentData
    setUpdateDatabaseRecordTemplate: (component) => {
      get().setComponentData(component);
    },

    setData: (data) => set({ data: JSON.parse(JSON.stringify(data)) }),

    setAvailableCols: (availableCols) => {
      set({ data: { ...get().data, availableColumns: [...availableCols] } });
    },

    setQueryData: (queryData) => {
      set({ data: { ...get().data, queries: [...queryData] } });
    },

    clearQueryData: () => {
      set({ data: { ...get().data, queries: [] } });
    },

    clearData: () => {
      set({ data: { ...get().data, columns: [] } });
    },

    setTargetDatabaseId: (targetDatabaseId) => {
      set({ data: { ...get().data, targetDatabaseId } });
    },

    setPlaceholders: (placeholders) => set({ placeholders: [...placeholders] }),

    setFocus: (index, focus) => {
      set({ position: index, focus, placeholders: [] });
    },

    // Override base getTemplate to include UI-only fields (placeholders, position, focus)
    getTemplate: () => {
      const s = get();
      return {
        componentId: s.componentId,
        name: s.name,
        data: JSON.parse(JSON.stringify(s.data)),
        type: s.type,
        lastModified: s.lastModified,
        placeholders: [...s.placeholders],
        position: s.position,
        focus: s.focus,
      };
    },
  }),
});

export { getQueryDatabaseStore };
export default defaultStore;
